import { Progress } from "@/components/ui/progress";
import { ElementType, FC } from "react";

type DimensionProgressProps = {
  percentage: number;
  color?: string;
  icon?: ElementType;
};

const DimensionProgress: FC<DimensionProgressProps> = (props) => {
  const { icon: Icon, color, percentage } = props;

  const finalColor = color || "#f1f5f9";

  return (
    <div className="flex items-center gap-2">
      <div
        className="flex h-7 w-7 items-center justify-center rounded-full text-white"
        style={{ background: finalColor }}
      >
        {Icon && <Icon size={20} />}
      </div>

      <div className="grow">
        <div className="text-xs font-medium text-[#8090A3]">{percentage}%</div>
        <Progress value={percentage} className="h-2" indicatorColor={color} />
      </div>
    </div>
  );
};

export default DimensionProgress;
